module.exports = "/_next/static/images/d4869cf1a84ce9e1e6a87d388bee3b0e-2-woman-working@2x.jpg";